"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllLabRequisitionsManager = void 0;
class AllLabRequisitionsManager {
    constructor(httpAdapter) {
        this.httpAdapter = httpAdapter;
        this._allLabRequisitionsData = { results: [], nextCursor: null };
    }
    get allLabRequisitionsData() {
        return this._allLabRequisitionsData;
    }
    fetchAllLabRequisitions(params, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter
                .getLabsAdapter()
                .getAllLabRequisitions(params, context);
            if (!response.isAborted) {
                this._allLabRequisitionsData = {
                    results: response.data.data.results,
                    nextCursor: response.data.data.nextCursor,
                };
            }
        });
    }
}
exports.AllLabRequisitionsManager = AllLabRequisitionsManager;
